import { render, staticRenderFns } from "./EN_ZapisiSpominaTemplate.vue?vue&type=template&id=c4c49f76&"
import script from "./EN_ZapisiSpominaTemplate.vue?vue&type=script&lang=js&"
export * from "./EN_ZapisiSpominaTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EN_ZapisiSpominaTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports